import './AboutUs.css'

const AboutUs = () => {
  return (
    <div>
      <div className='aboutus-about' data-aos="fade-up"
        data-aos-duration="1000">
        <div className='aboutus-heading'>
          <h2>ABOUT US</h2>
          <hr />
        </div>
        <h3>welcome to Avenue One</h3>
        {/* <h4>where every milestone is a step towards a luxury living.</h4> */}
        <div className='aboutus-body'>
          <p>Avenue One Developments is creating a portfolio of premium high-rise, mixed-use, commercial,
            and residential projects designed for modern lifestyles, commercial visibility, and long-term real
            estate value.
            With The Square and The Park already on ground and near completion, and upcoming projects
            including The Swiss, The Orchid, and The Corner, The Grand Avenue One is building a
            portfolio guided by one clear promise:
            Location. Quality. Timely Delivery.</p>
        </div>
      </div>
    </div>
  )
}

export default AboutUs